import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { getExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsLists';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';

export module RecycleBinUtils {
  export const getRecycleBinSiteSettingEnabled: () => (boolean) = () => {
    return getSessionManagementServiceInstance().isRecycleBinEnabledOnSite();
  };

  export function isRecycleBinEnabled(): boolean {
    return FeatureFlags.recycleBinExpEnabled && getRecycleBinSiteSettingEnabled();
  }

  export function getLocalizedContentType(contentType: ExplorableItemType, plural?: boolean,
                                          manualCapitalize?: boolean): string {
    const typeDefinition = getExplorableItemDefinition(contentType);
    if (_.isUndefined(typeDefinition)) {
      throw new Error('Tried to localize unrecognized content type string: ' + contentType);
    }
    let value = plural ? typeDefinition.pluralName() : typeDefinition.singularName();
    return manualCapitalize ? capitalizeFirstLetter(value) : value;
  }

  function capitalizeFirstLetter(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Number of days recycled content should persist before hard deletion
  // NOTE: I can't call these enums in expectedRequestBody.ts (i.e. no
  // RecycleBinUtils.RecycleBinContentLifespans.RECYCLE_BIN_LARGE_LIFE) so if you change the value of
  // RECYCLE_BIN_LARGE_LIFE in this file, change it in
  // test/webdriver/integration/mocks/api/createSite/expectedRequestBody.ts and also in monolith
  // .../tab-domain-site-interfaces/src/com/tableausoftware/domain/site/RecycleBinConstants.java
  export class RecycleBinContentLifespans {
    static RECYCLE_BIN_LARGE_LIFE = 30;
    static RECYCLE_BIN_MEDIUM_LIFE = 7;
    static RECYCLE_BIN_SMALL_LIFE = 1;
  }

  // filters that are not relevant in the Recycle Bin space and should be removed from RB AdvancedFilterPanel
  export const RECYCLE_BIN_EXCLUDED_FILTERS = new Set<string>([
    ContentFiltersKeys.location,
    ContentFiltersKeys.tag,
    ContentFiltersKeys.includeLiveToDataEngine,
    ContentFiltersKeys.extractStatus,
    ContentFiltersKeys.workbookConnFilter,
    ContentFiltersKeys.showEmbedded,
    ContentFiltersKeys.connectionType,
    ContentFiltersKeys.serverName,
    ContentFiltersKeys.serverPort,
    ContentFiltersKeys.databaseUsername,
    ContentFiltersKeys.hasPassword,
    ContentFiltersKeys.isCertified,
    ContentFiltersKeys.recent,
    ContentFiltersKeys.hasAlert,
    ContentFiltersKeys.usersPersonalSpaceContent,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.modifiedBefore,
    ContentFiltersKeys.modifiedAfter,
  ]);

  // filters that are only relevant in the Recycle Bin space and should be included in RB AdvancedFilterPanel
  export const RECYCLE_BIN_SPECIFIC_FILTERS = new Set<string>([
    ContentFiltersKeys.deletedBefore,
    ContentFiltersKeys.deletedAfter,
  ]);
}